import type { DiagramDocument, DiagramEdge, DiagramNode } from './types';
import { DEFAULT_NODE_STYLE } from './defaults';

export function normalizeNode(node: DiagramNode): DiagramNode {
  return {
    ...node,
    rotation: Number.isFinite(node.rotation) ? node.rotation : 0,
    style: { ...DEFAULT_NODE_STYLE, ...node.style },
    data: node.data && typeof node.data === 'object' ? { ...node.data } : {},
    locked: node.locked ?? false,
    hidden: node.hidden ?? false,
    groupId: node.groupId ?? null,
    entityFields: Array.isArray(node.entityFields) ? node.entityFields.filter((field) => field && typeof field === 'object').map((field) => ({ id: field.id, name: String(field.name ?? ''), dataType: String(field.dataType ?? 'TEXT'), primaryKey: Boolean(field.primaryKey), foreignKey: Boolean(field.foreignKey), nullable: field.nullable !== false })) : undefined,
    umlAttributes: Array.isArray(node.umlAttributes) ? node.umlAttributes.filter((item) => typeof item === 'string').slice(0, 500) : undefined,
    umlMethods: Array.isArray(node.umlMethods) ? node.umlMethods.filter((item) => typeof item === 'string').slice(0, 500) : undefined,
  };
}

export function normalizeEdge(edge: DiagramEdge): DiagramEdge {
  return {
    ...edge,
    arrowStart: edge.arrowStart ?? false,
    arrowEnd: edge.arrowEnd ?? true,
    startMarker: edge.startMarker,
    endMarker: edge.endMarker,
    sourceAnchor: edge.sourceAnchor ?? 'auto',
    targetAnchor: edge.targetAnchor ?? 'auto',
    linePattern: edge.linePattern ?? 'solid',
    routingMode: edge.routingMode ?? ((edge.waypoints?.length ?? 0) > 0 ? 'manual' : 'auto'),
    waypoints: Array.isArray(edge.waypoints) ? edge.waypoints.filter((point) => Number.isFinite(point?.x) && Number.isFinite(point?.y)).map((point) => ({ x: point.x, y: point.y })) : [],
    sourceCardinality: edge.sourceCardinality,
    targetCardinality: edge.targetCardinality,
    relationshipType: edge.relationshipType,
    bundleId: typeof edge.bundleId === 'string' && edge.bundleId.trim() ? edge.bundleId.trim().slice(0, 160) : null,
  };
}

export function normalizeDocument(document: DiagramDocument): DiagramDocument {
  return {
    ...document,
    metadata: { app: 'OWDEX Draw', version: '1.0.0-rc3' },
    pages: document.pages.map((page) => ({
      ...page,
      nodes: page.nodes.map(normalizeNode),
      edges: page.edges.map(normalizeEdge),
    })),
  };
}
